const WARM_WINDOW_MS = 200;

let queued = new Set<string>();
let scheduledWarm: ReturnType<typeof setTimeout> | null = null;

function hasServiceWorker() {
  return typeof navigator !== "undefined" && "serviceWorker" in navigator;
}

export function warmImageCache(urls: string[]) {
  if (!hasServiceWorker()) return;

  urls.forEach((url) => queued.add(url));
  if (queued.size === 0 || scheduledWarm !== null) return;

  scheduledWarm = setTimeout(sendToServiceWorker, WARM_WINDOW_MS);
}

async function sendToServiceWorker() {
  scheduledWarm = null;
  const urls = [...queued];
  queued = new Set();
  if (urls.length === 0) return;

  try {
    const registration = await navigator.serviceWorker.ready;
    registration.active?.postMessage({ type: "warm-image-cache", urls });
  } catch (error) {
    console.error("Could not ask the service worker to cache the images", error);
  }
}
